
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startCarguerosXPlanilla, startPlanillasXLoteDistri, startPlanillaXID } from "../../../services";





export const usePlanillaXID = (id) => {
    const planillaXIDQuery = useQuery({
        queryKey: ['planilla-id', id], 
        queryFn: () => startPlanillaXID(id),
    });

    return { planillaXIDQuery }
}



export const useCarguerosXPlanilla = (id) => {
    const carguerosXPlanilla = useQuery({
        queryKey: ['cargueros-planilla', id], 
        queryFn: () => startCarguerosXPlanilla(id),
    });

    return { carguerosXPlanilla }
}





export const usePlanillasXLoteDistri = (id) => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');
  
    const planillaLoteQuery = useQuery({
        queryKey: ['planilla-lote', { page, id, termino }], 
        queryFn: () => startPlanillasXLoteDistri({ page, id, termino }),
    });

    const chagePage = (num) => {
        setPage(num - 1);
    }
    
    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        planillaLoteQuery,
    }
}


